import { AnimationFactory } from './AnimationFactory';
import { Curves } from './Curves';

export const Animations = {
	Bounce: (height: number) =>
		new AnimationFactory(`bounce`)
			.TargetingCSSProperty('transform')
			.WithPrerequisiteStyles({ display: `block` })
			.WithMaximumValue(height)
			.TransformUsing((value: number) => `translateY(${-1 * value}px)`)
			.UsingCurve(Curves.Jump()),

	
	Bounce3D: (bounceHeight: number, duration: number) => {
		const bounceAndZoomOut = new AnimationFactory(`zoomOut`)
			.WithPrerequisiteStyles({ display: `block` })
			.TargetingCSSProperty('transform')
			.WithMaximumValue(bounceHeight)
			.UsingCurve(Curves.Jump())
			.ForDuration(duration)
			.TransformUsing((value: number) => `translateY(${-1 * value}px) scale(${value * 0.002 + 1})`);

		const brighten = Animations.Brighten(bounceHeight * 0.002).ForDuration(duration);
		return bounceAndZoomOut.CombineWith(brighten);
	},

	Spin: () =>
		new AnimationFactory(`spin`)
			.TargetingCSSProperty('transform')
			.WithPrerequisiteStyles({ display: `block` })
			.WithMaximumValue(360)
			.TransformUsing((value: number) => `rotate(${value}deg)`)
			.OneWay()
			.UsingCurve(Curves.Ease()),

	ZoomOut: (scaleUpBy: number) =>
		new AnimationFactory(`zoomOut`)
			.WithPrerequisiteStyles({ display: `block` })
			.TargetingCSSProperty('transform')
			.WithMaximumValue(scaleUpBy)
			.UsingCurve(Curves.Jump())
			.TransformUsing((value: number) => `scale(${value + 1})`),

	Brighten: (increaseBy: number) =>
		new AnimationFactory(`brighten`)
			.TargetingCSSProperty('filter')
			.WithMaximumValue(increaseBy)
			.TransformUsing((value: number) => `brightness(${value + 1})`)
			.UsingCurve(Curves.Jump()),

	FadeIn: () => new AnimationFactory(`fadeIn`).TargetingCSSProperty('opacity').WithMaximumValue(1).OneWay()
};
